
// import React, { useState } from "react";
import { TextField, Checkbox, Button, IconButton, Box, Typography, FormControl, InputLabel } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { Divider } from "antd";
// import ShiftsTable from "./ShiftsTable";
import MUIMultiSelect from "./MUIMultiSelect";
import moment from "moment";

const ShiftsModel = (props) => {

    const { weekShifts, setWeekShifts } = props;

    // Function to convert "HH:MM" to milliseconds
    const timeToMilliseconds = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        let date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).unix() * 1000;
    };

    // Function to add shift
    const addShift = () => {
        let newStart = "06:00"; // Default start time for the first shift
        let newEnd = calculateEndTime(newStart); // Calculate end time based on duration
        const shifts = [...weekShifts];

        // If there are already shifts, the new shift starts one minute after the last shift
        if (shifts.length > 0) {
            newStart = getNextShiftStart(shifts[shifts.length - 1].end);
            newEnd = calculateEndTime(newStart);
        }

        const newShift = { start: newStart, end: newEnd, unmanned: false, weekdays: ["Mo"], startUnix: timeToMilliseconds(newStart), endUnix: timeToMilliseconds(newEnd) };
        setWeekShifts([...weekShifts, newShift]);

    };

    // Function to calculate the end time based on a 7:59 duration
    const calculateEndTime = (startTime) => {
        const [startHour, startMinute] = startTime.split(":").map(Number);
        let endHour = startHour + 7;
        let endMinute = startMinute + 59;

        if (endMinute >= 60) {
            endHour += 1;
            endMinute -= 60;
        }

        // If end time exceeds 23:59, set it to 23:59
        if (endHour > 23) {
            endHour = 23;
            endMinute = 59;
        }

        return `${String(endHour).padStart(2, "0")}:${String(endMinute).padStart(2, "0")}`;
    };

    // Function to get the next shift start time (1 minute after the previous shift's end time)
    const getNextShiftStart = (previousEndTime) => {
        const [endHour, endMinute] = previousEndTime.split(":").map(Number);
        let newStartHour = endHour;
        let newStartMinute = endMinute + 1;

        if (newStartMinute >= 60) {
            newStartHour += 1;
            newStartMinute -= 60;
        }

        // If the new start hour exceeds 23, return 23:59 as the start
        if (newStartHour > 23) {
            return "23:59";
        }

        return `${String(newStartHour).padStart(2, "0")}:${String(newStartMinute).padStart(2, "0")}`;
    };

    // Function to update shift values
    const updateShift = (index, field, value) => {
        const shifts = [...weekShifts];
        shifts[index][field] = value;
        setWeekShifts(shifts);
    };

    // Function to remove shift
    const removeShift = (index) => {
        const shifts = weekShifts.filter((_, i) => i !== index);
        setWeekShifts(shifts);
    };


    return (
        <Box className="eqShifts">
            {/* todo render table form */}
            <>
                {[{ label: "Schichten Wochentage" }].map(({ label }, index) => {

                    return (
                        <Box key={index} mb={3}>
                            <Typography className="title" variant="h6">{label} ({weekShifts.length})</Typography>
                            <br />
                            <div className="shiftsWrapper" style={{ maxHeight: props.style.maxHeight ? props.style.maxHeight : "auto"}}>

                                {weekShifts.map((shift, index) => (
                                    <>
                                        {index > 0 ? <Divider orientation="horizontal" style={{ margin: "10px 0px 10px 0px" }} /> : ""}
                                        <Box key={index} display="flex" alignItems="center" gap={2} mt={0}>
                                            <MUIMultiSelect value={shift.weekdays} onChange={(e) => updateShift(index, "weekdays", e)} />
                                            <TextField inputProps={{ "data-testid": "txtf_start_shift_time" }} label="Startzeit" type="time" style={{ width: "120px" }} value={shift.start} onChange={(e) => updateShift(index, "start", e.target.value)} />
                                            <TextField inputProps={{ "data-testid": "txtf_end_shift_time" }} label={(shift.start.split(":")[0] > shift.end.split(":")[0]) ? "Endzeit (+1)" : "Endzeit"} type="time" style={{ width: "120px", marginRight: "10px" }} value={shift.end} onChange={(e) => updateShift(index, "end", e.target.value)} />
                                            <Checkbox style={{ padding: 0 }} inputProps={{ "data-testid": "btn_check_shift" }} checked={shift.unmanned} onChange={(e) => updateShift(index, "unmanned", e.target.checked)} />
                                            <Typography className="checkboxTitle">Schicht ist unbemannt</Typography>
                                            <IconButton color="error" onClick={() => removeShift(index)} data-testid="btn_remove_shift">
                                                <DeleteForeverOutlinedIcon
                                                    style={{
                                                        color: "red",
                                                        cursor: "pointer",
                                                    }} />
                                            </IconButton>
                                        </Box>
                                    </>
                                ))}
                            </div>

                            <Button variant="outlined" data-testId={"btn_add_shift"} onClick={() => addShift()} sx={{ mt: 2 }} >
                                + Schicht
                            </Button>
                        </Box>)
                }
                )}</>
            <br />
        </Box>
    );
};

export default ShiftsModel;